<template>
  <div class="mx-3 my-3">
    <div v-if="loading" class="d-flex justify-center align-center pa-4">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div v-else>
      <div v-if="evaluateStudents.length === 0" class="text-center pa-4 grey--text">Không có dữ liệu</div>

      <v-row>
        <v-col v-for="(group, index) in groupedEvaluates" :key="index" cols="12" md="6">
          <v-card outlined height="100%">
            <v-card-title class="primary white--text"> Buổi học {{ formatDate(group.lesson.date) }} </v-card-title>
            <v-card-text class="pa-2">
              <v-list>
                <v-list-item v-for="criteria in group.evaluate_criteria" :key="criteria._id">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">
                      {{ criteria.title }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="mt-1">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" v-if="criteria.type === 'multiplechoice'">
                            {{ getValueForCriteria(group.value, criteria._id) }}
                          </span>
                          <span v-bind="attrs" v-on="on" v-else>
                            {{ getValueForCriteria(group.value, criteria._id) }}
                          </span>
                        </template>
                        <span>{{ getValueForCriteria(group.value, criteria._id) }}</span>
                      </v-tooltip>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <div class="d-flex justify-center mt-4">
        <v-btn icon :disabled="options.page === 1" @click="changePage(options.page - 1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        <v-btn
          v-for="pageNumber in visiblePages"
          :key="pageNumber"
          text
          :color="pageNumber === options.page ? 'primary' : ''"
          class="mx-1"
          @click="changePage(pageNumber)"
        >
          {{ pageNumber }}
        </v-btn>

        <v-btn
          icon
          :disabled="options.page >= Math.ceil(totalItems / itemsPerPage)"
          @click="changePage(options.page + 1)"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      evaluateStudents: [],
      options: {
        page: 1,
      },
      itemsPerPage: 5,
      totalItems: 0,
    }
  },
  computed: {
    groupedEvaluates() {
      return this.evaluateStudents
    },
    visiblePages() {
      const totalPages = Math.ceil(this.totalItems / this.itemsPerPage)
      const current = this.options.page
      const delta = 2
      const range = []
      const rangeWithDots = []
      let l

      for (let i = 1; i <= totalPages; i++) {
        if (i === 1 || i === totalPages || (i >= current - delta && i <= current + delta)) {
          range.push(i)
        }
      }

      range.forEach((i) => {
        if (l) {
          if (i - l === 2) {
            rangeWithDots.push(l + 1)
          } else if (i - l !== 1) {
            rangeWithDots.push('...')
          }
        }
        rangeWithDots.push(i)
        l = i
      })

      return rangeWithDots
    },
  },
  methods: {
    ...mapActions('evaluateStudent', ['fetchEvaluateStudents', 'countEvaluateStudents']),
    formatDate(date) {
      return this.$moment(date).format('DD/MM/YYYY')
    },
    getValueForCriteria(values, criteriaId) {
      const value = values.find((v) => v.id === criteriaId)
      if (!value) return ''

      if (Array.isArray(value.value)) {
        return value.value.join(', ')
      }
      return value.value
    },
    async fetchData() {
      this.loading = true
      try {
        const { page } = this.options
        const params = {
          class: this.item.class.id,
          student: this.item.student.id,
          _limit: this.itemsPerPage,
          _start: (page - 1) * this.itemsPerPage,
        }

        const [response, count] = await Promise.all([
          this.fetchEvaluateStudents(params),
          this.countEvaluateStudents(params),
        ])

        this.totalItems = count

        if (response && response.length > 0) {
          this.evaluateStudents = response
        } else {
          this.evaluateStudents = []
        }
      } catch (error) {
        console.error('Error fetching evaluate students:', error)
      } finally {
        this.loading = false
      }
    },
    changePage(page) {
      if (page === '...') return
      this.options.page = page
      this.fetchData()
    },
  },
  created() {
    this.fetchData()
  },
}
</script>
